/* eslint-disable react/require-default-props */
import React from 'react';

import { SwitchRoot, HiddenInput, Track, Thumb, LabelText } from './styles';

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
  id?: string;
  name?: string;
  'aria-label'?: string;
  className?: string;
}

let uidCounter = 0;

const Switch = ({
  checked,
  onChange,
  label,
  disabled = false,
  id,
  name,
  'aria-label': ariaLabel,
  className,
}: SwitchProps): React.ReactElement => {
  const generatedId = React.useRef(`switch-${(uidCounter += 1)}`).current;
  const inputId = id ?? (label ? generatedId : undefined);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (!disabled) onChange(e.target.checked);
  };

  return (
    <SwitchRoot $disabled={disabled} className={className}>
      <HiddenInput
        type="checkbox"
        role="switch"
        id={inputId}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        aria-checked={checked}
        aria-label={ariaLabel}
      />
      <Track $checked={checked} $disabled={disabled} aria-hidden="true">
        <Thumb $checked={checked} $disabled={disabled} />
      </Track>
      {label && <LabelText $disabled={disabled}>{label}</LabelText>}
    </SwitchRoot>
  );
};

export default Switch;
